/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import Spin from "../../common/Spin";
import { toast } from "react-toastify";
import { API, fileUpload, get } from "../../../config";
import { AddChartOfAccountSchema } from "../../common/Validation";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import InputMask from "react-input-mask";
import { getImportLogDetail } from "./ImportLogsHelper";
import ChartOfAccountSelect from "../../common/ChartOfAccountSelect";

const NotImportedLogEdit = ({
  logId,
  toggleEditModal,
  projectId,
  fetchNotImportedLogs,
  editModal,
}) => {
  const [loading, setLoading] = useState(false);
  const [chartOfAccountId, setChartOfAccountId] = useState();
  const [disableOptionalInput, setDisableOptionalInput] = useState(true);

  const [accountData, setAccountData] = useState();
  const formValues = useRef();

  const [accountTpesLoading, setAccountTpesLoading] = useState();
  const [accountTypesList, setAccountTypesList] = useState();

  const fetchAccountTypes = useCallback(async () => {
    try {
      setAccountTpesLoading(true);
      const { data } = await get(`${API.GET_ACCOUNT_TYPES}`);
      setAccountTpesLoading(false);
      const accountTypesList = data.data;
      setAccountTypesList(accountTypesList);
      return data.data;
    } catch (error) {
      setAccountTpesLoading(false);
      setAccountTypesList([]);

      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
      } else {
        toast.error(error?.message);
      }
    }
  }, []);

  const accuntingList = accountTypesList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const accountTypeValue = accuntingList?.find(
    (item) => item?.label === accountData?.account_type
  );

  const typeList = [
    { label: "Debit", value: "0" },
    { label: "Credit", value: "1" },
  ];
  const typeValue = typeList?.find(
    (item) => parseInt(item?.value) == accountData?.type
  );

  const taxList = [
    { label: "GST 10%", value: 1 },
    { label: "GST Excluded", value: 0 },
    { label: "BAS Excluded", value: 2 },
    { label: "GST on Imports", value: 3 },
  ];
  const taxValue = taxList?.find(
    (item) => parseInt(item?.value) == accountData?.tax
  );

  useEffect(() => {
    fetchAccountTypes();
  }, [fetchAccountTypes]);

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.account_type_id = value?.account_type_id?.value
      ? value?.account_type_id?.value
      : "";
    value.type = value?.type?.value ? parseInt(value?.type?.value) : "";
    value.tax = value?.tax?.value ? parseInt(value?.tax?.value) : 0;
    value.code = value?.code ? value?.code : "";
    value.sub_code = value?.sub_code ? value?.sub_code : "";
    value.accounting_code = value?.code ? parseInt(value?.accounting_code) : "";

    if (chartOfAccountId?.value !== "other") {
      formData.append(
        "chart_of_account_id",
        chartOfAccountId?.id ? chartOfAccountId?.id : ""
      );
    }

    formData.append("builder_project_id", projectId);
    formData.append("account_type_id", value?.account_type_id);
    formData.append("type", value?.type);
    formData.append("tax", value?.tax);
    formData.append("code", value?.code);
    formData.append("accounting_code", value?.accounting_code);
    formData.append("sub_code", value?.sub_code);
    formData.append("name", value?.name ? value?.name : "");
    formData.append(
      "description",
      value?.description ? value?.description : ""
    );
    formData.append("_method", "put");

    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.COA_IMPORT_LOGS}/${logId}`,
        formData
      );
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        toggleEditModal();
        fetchNotImportedLogs();
      }
      return data?.data;
    } catch (error) {
      setAccountData(value);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const data = await getImportLogDetail(logId, projectId);
        setAccountData(data);
        setLoading(false);
      } catch (e) {
        setAccountData(null);
      }
    }
    fetchData();
  }, [logId, projectId]);

  return (
    <>
      <Modal
        size="lg"
        show={editModal}
        onHide={toggleEditModal}
        dialogClassName="modal-50w larg-popup review-popup small-review not-import-edit"
        aria-labelledby="contained-modal-title-vcenter"
        className="project-section"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Edit Chart of Accounts
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              account_type_id: accountTypeValue,
              type: typeValue,
              tax: taxValue,
              name: accountData?.name,
              code: accountData?.code,
              sub_code: accountData?.sub_code,
              accounting_code: accountData?.accounting_code,
              description: accountData?.description,
            }}
            enableReinitialize
            innerRef={formValues}
            onSubmit={handleFormSubmit}
            validateOnBlur={true}
            validateOnChange={true}
            validationSchema={AddChartOfAccountSchema}
          >
            {({
              values,
              setErrors,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <>
                  {loading && <Spin />}
                  <form
                    onSubmit={handleSubmit}
                    noValidate
                    className="entry-section"
                  >
                    <div className="form-box">
                      <div className="form-group full-width">
                        <label>Chart of Account</label>
                        <ChartOfAccountSelect
                          name="chart_of_account_id"
                          onChange={(e) => {
                            // handleNewAccountSelection(e, index, finalData);

                            if (
                              e?.import_uuid !== accountData?.import_uuid &&
                              e?.value !== "other" &&
                              e?.import_uuid
                            ) {
                              toast.warn(
                                "Selected Chart of Account has already been synced with another Xero record."
                              );
                            }
                            setFieldValue(
                              "name",
                              accountData?.name ? accountData?.name : ""
                            );
                            setFieldValue(
                              "description",
                              accountData?.description
                                ? accountData?.description
                                : ""
                            );
                            setFieldValue("code", e?.code ? e?.code : "");
                            setFieldValue(
                              "sub_code",
                              e?.sub_code ? e?.sub_code : ""
                            );
                            setChartOfAccountId(e);
                            if (e?.value === "other") {
                              setDisableOptionalInput(true);
                            } else {
                              setDisableOptionalInput(false);
                            }
                          }}
                          className="contactname-select"
                          projectId={projectId}
                          placeholder="Select Account"
                          isClearable={false}
                          other={true}
                        />
                      </div>
                      <div className="form-group half-width">
                        <label>
                          <span className="required">*</span>Account Type
                        </label>
                        <Select
                          name="account_type_id"
                          value={
                            values?.account_type_id
                              ? values?.account_type_id
                              : ""
                          }
                          onChange={(e) => {
                            setFieldValue(`account_type_id`, e ? e : "");
                          }}
                          isDisabled={true}
                          onBlur={handleBlur}
                          options={accuntingList}
                          placeholder="Select Account Type"
                          classNamePrefix="selectbox"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: "grey",
                            },
                          })}
                          isLoading={accountTpesLoading}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="account_type_id" />
                        </span>
                      </div>
                      <div className="form-group half-width">
                        <label>
                          <span className="required">*</span>Type
                        </label>
                        <Select
                          name="type"
                          value={values?.type ? values?.type : ""}
                          onChange={(e) => {
                            setFieldValue(`type`, e ? e : "");
                          }}
                          isDisabled={true}
                          onBlur={handleBlur}
                          options={typeList}
                          placeholder="Select Type"
                          classNamePrefix="selectbox"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: "grey",
                            },
                          })}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="type" />
                        </span>
                      </div>
                      <div className="form-group half-width">
                        <label>
                          <span className="required">*</span>Tax
                        </label>

                        <Select
                          name="tax"
                          value={values?.tax ? values?.tax : ""}
                          onChange={(e) => {
                            setFieldValue(`tax`, e ? e : "");
                          }}
                          isDisabled={true}
                          onBlur={handleBlur}
                          options={taxList}
                          placeholder="Select Tax"
                          classNamePrefix="selectbox"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: "grey",
                            },
                          })}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                        />

                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="tax" />
                        </span>
                      </div>
                      <div className="form-group half-width">
                        <label>
                          <span className="required">*</span>Name
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={values?.name ? values?.name : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={disableOptionalInput ? false : true}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="name" />
                        </span>
                      </div>

                      <div className="form-group half-width">
                        <label>
                          <span className="required">*</span>BuildTrust Code
                        </label>
                        <InputMask
                          type="text"
                          name="code"
                          value={values?.code ? values?.code : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={disableOptionalInput ? false : true}
                          mask="999999999999"
                          maskChar={null}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="code" />
                        </span>
                      </div>
                      <div className="form-group half-width">
                        <label>BuildTrust Sub Code</label>
                        <InputMask
                          type="text"
                          name="sub_code"
                          value={values?.sub_code ? values?.sub_code : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={disableOptionalInput ? false : true}
                          mask="9999"
                          maskChar={null}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="sub_code" />
                        </span>
                      </div>
                      <div className="form-group half-width">
                        <label>Accounting Software Code</label>
                        <InputMask
                          type="text"
                          name="accounting_code"
                          value={
                            values?.accounting_code
                              ? values?.accounting_code
                              : ""
                          }
                          onChange={handleChange}
                          disabled={true}
                          onBlur={handleBlur}
                          mask="999999999999"
                          maskChar={null}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="accounting_code" />
                        </span>
                      </div>
                      <div className="form-group full-width">
                        <label>Description</label>
                        <textarea
                          type="text"
                          name="description"
                          value={values?.description ? values?.description : ""}
                          onChange={handleChange}
                          disabled={disableOptionalInput ? false : true}
                          onBlur={handleBlur}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                          style={{
                            borderRadius: "10px",
                            margin: "0 0 15px",
                            minHeight: "70px",
                          }}
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="description" />
                        </span>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <Button
                        type="Button"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                          toggleEditModal();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button type="submit">Save</Button>
                    </div>
                  </form>
                </>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NotImportedLogEdit;
